import { Form } from 'react-bootstrap';
import { FEMA_PASSWORD_LABELS } from '../../../../config/femaCredentials.config';

/**
 * The two password fields. They are UNCONTROLLED on purpose: no `value` prop, so React state
 * never holds a password. Each change goes to the caller's ref through `onChange`. The caller
 * empties the inputs through `fieldRefs` after each call, after an error and on unmount.
 *
 * `type="password"` and `autoComplete="off"` on each field (precedent: SystemModal.jsx).
 *
 * @param {{
 *   kind: 'keystore' | 'pem',
 *   idPrefix: string,
 *   fieldRefs: {
 *     keystorePassword: import('react').RefObject<HTMLInputElement>,
 *     privateKeyPassword: import('react').RefObject<HTMLInputElement>,
 *   },
 *   onChange: (field: 'keystorePassword' | 'privateKeyPassword', value: string) => void,
 * }} props
 */
const PasswordFields = ({ kind, idPrefix, fieldRefs, onChange }) => (
  <>
    {kind === 'keystore' ? (
      <Form.Group className="mb-3" controlId={`${idPrefix}-keystore-password`}>
        <Form.Label>{FEMA_PASSWORD_LABELS.keystorePassword}</Form.Label>
        <Form.Control
          ref={fieldRefs.keystorePassword}
          type="password"
          name="keystorePassword"
          autoComplete="off"
          maxLength={256}
          aria-describedby={`${idPrefix}-keystore-password-help`}
          onChange={(event) => onChange('keystorePassword', event.target.value)}
        />
        <Form.Text id={`${idPrefix}-keystore-password-help`}>
          {FEMA_PASSWORD_LABELS.keystorePasswordHelp}
        </Form.Text>
      </Form.Group>
    ) : null}
    <Form.Group className="mb-3" controlId={`${idPrefix}-private-key-password`}>
      <Form.Label>
        {FEMA_PASSWORD_LABELS.privateKeyPassword}
        {kind === 'pem' ? ' (only when the key is encrypted)' : ''}
      </Form.Label>
      <Form.Control
        ref={fieldRefs.privateKeyPassword}
        type="password"
        name="privateKeyPassword"
        autoComplete="off"
        maxLength={256}
        aria-describedby={`${idPrefix}-private-key-password-help`}
        onChange={(event) => onChange('privateKeyPassword', event.target.value)}
      />
      <Form.Text id={`${idPrefix}-private-key-password-help`}>
        {FEMA_PASSWORD_LABELS.privateKeyPasswordHelp}
      </Form.Text>
    </Form.Group>
  </>
);

/** A JKS needs both passwords; a PEM key needs none when it is not encrypted. */
export const passwordsReady = (kind, filled) =>
  kind === 'keystore' ? filled.keystorePassword && filled.privateKeyPassword : true;

export default PasswordFields;
